import { AccountDetails } from "../store/AuthContext";

export const getShippingAddress = (details?: AccountDetails | null) => {
  if (!details) {
    return "";
  }

  const { address, postalCode, city } = details;

  const shippingAddress = address || "";
  const shippingPostalCode = postalCode || "";
  const shippingCity = city || "";

  return shippingAddress + ", " + shippingPostalCode + " " + shippingCity;
};
